import { Delete, ZoomIn } from "@mui/icons-material";
import {
  Box,
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Paper,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useDropzone } from "react-dropzone";
import { useDispatch, useSelector } from "react-redux";
import store from "../Store";
import DynamicImgResizeComponent from "./DynamicImgResizeComponent";
import { FileUploadAreaAndPreviewReducerAction } from "../Store/FileUploadAreaAndPreviewReducer";

const FileUploadAreaAndPreview = ({ maxFileCount }) => {
  const dispatch = useDispatch();
  const activeFileUploadAreaData = useSelector(
    (state) => state.fileUploadAreaAndPreview.activeFileUploadAreaData
  );
  const thumbsContainer = {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    marginTop: 16,
    width: "auto",
    height: "auto",
  };

  const dropzone = {
    margin: 8,
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: 8,
    borderWidth: 2,
    borderRadius: 2,
    borderColor: "#eeeeee",
    borderStyle: "dashed",
    backgroundColor: "#fafafa",
    color: "#bdbdbd",
    outline: "none",
    transition: "border .24s ease-in-out",
    width: "100%",
    height: window.innerHeight / 8,
  };

  const uploadedFilesAreaStyles = {
    width: "100%",
    height: window.innerHeight / 3,
    overflowX: "hidden",
    overflowY: "scroll",
    borderWidth: 2,
    borderRadius: 2,
    borderColor: "#eeeeee",
    borderStyle: "dashed",
  };

  const thumb = {
    display: "inline-flex",
    borderRadius: 2,
    border: "1px solid #eaeaea",
    marginBottom: 8,
    marginRight: 8,
    width: 200,
    height: 200,
    padding: 4,
    boxSizing: "border-box",
  };

  const thumbInner = {
    display: "flex",
    minWidth: 0,
    overflow: "hidden",
  };

  const img = {
    display: "block",
    width: 200,
    height: 200,
  };

  // preview Dlg properties.

  const imgWidth = window.innerWidth - 100;
  const imgHeight = window.innerHeight - 200;
  const imageProps = {
    targetWidth: imgWidth,
    targetHeight: imgHeight,
  };
  const [dlgOpen, setDlgOpen] = useState(false);
  const [selectedPreviewFile, setSelectedPreviewFile] = useState(null);
  const [previewBtnVisible, setPreviewBtnVisible] = useState({
    currentTargetKey: null,
    visible: false,
  });

  const pdf = {
    display: "block",
    width: imgWidth,
    height: imgHeight,
  };
  // end of preview dlg properties

  const fileInputRef = useRef(null);

  const triggerFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const { acceptedFiles, fileRejections, getRootProps, getInputProps } =
    useDropzone({
      maxFiles: maxFileCount,
      minSize: 0,
      maxSize: 5000000,
      noClick: false,
      noDrag: false,
      accept: {
        "image/*": [".png", ".jpg"],
        "application/pdf": [".pdf"],
      },
      onDrop: (acceptedFiles) => {
        const currentData =
          store.getState().fileUploadAreaAndPreview.activeFileUploadAreaData;
        const currentValues = currentData.uploadAreaFiles;
        const updatedValues = [...currentValues].concat(
          acceptedFiles.map((file) =>
            Object.assign(file, {
              preview: URL.createObjectURL(file),
            })
          )
        );
        dispatch(
          FileUploadAreaAndPreviewReducerAction.updateUploadAreaFiles(
            updatedValues
          )
        );
        fileInputRef.current.value = null;
      },
    });

  const acceptedFileItems = activeFileUploadAreaData.uploadAreaFiles.map(
    (file) => (
      <li key={file.name}>
        <Typography sx={{ fontFamily: "Roboto" }}>
          {file.name} - {file.size} bytes
        </Typography>
      </li>
    )
  );

  const fileRejectionItems = fileRejections.map(({ file, errors }) => {
    return (
      <li key={file.name}>
        <Typography sx={{ fontFamily: "Roboto" }}>
          {file.name} - {file.size} bytes
        </Typography>
        <ul>
          {errors.map((e) => (
            <li key={e.code}>{e.message}</li>
          ))}
        </ul>
      </li>
    );
  });

  const thumbs = activeFileUploadAreaData.uploadAreaFiles.map((file, index) => (
    <div style={thumb} key={file.name + index}>
      <Card
        sx={thumbInner}
        onMouseOver={() => {
          setPreviewBtnVisible({
            currentTargetKey: file.name,
            visible: true,
          });
        }}
        onMouseLeave={() => {
          setPreviewBtnVisible({ currentTargetKey: null, visible: false });
        }}
      >
        {previewBtnVisible &&
          previewBtnVisible.currentTargetKey === file.name && (
            <ZoomIn
              onClick={() => {
                setSelectedPreviewFile(file);
                setDlgOpen(true);
              }}
            />
          )}
        {previewBtnVisible &&
          previewBtnVisible.currentTargetKey === file.name && (
            <Delete
              sx={{ color: "grey" }}
              fontSize="small"
              onClick={() => {
                const latestData =
                  store.getState().fileUploadAreaAndPreview
                    .activeFileUploadAreaData;
                const latestFiles = latestData.uploadAreaFiles;
                const filteredRecords = latestFiles.filter(
                  (recordFile) => recordFile.name !== file.name
                );
                dispatch(
                  FileUploadAreaAndPreviewReducerAction.updateUploadAreaFiles(
                    filteredRecords
                  )
                );
              }}
            />
          )}
        <object data={file.preview} style={img} />
      </Card>
    </div>
  ));

  useEffect(() => {}, [selectedPreviewFile]);

  return (
    <React.Fragment>
      <section className="container">
        <div style={dropzone} onClick={triggerFileInput}>
          <div {...getRootProps({ className: "dropzone" })}>
            <input {...getInputProps()} ref={fileInputRef} />
            <Typography variant="span" sx={{ fontFamily: "Roboto" }}>
              Select files (Only *.jpeg and *.png images or Pdf will be accepted
              of Max size 5 MB)
            </Typography>
          </div>
        </div>
        {activeFileUploadAreaData.uploadAreaFiles &&
          activeFileUploadAreaData.uploadAreaFiles.length > 0 && (
            <Box
              sx={{
                float: "right",
                margin: "8px",
                display: "inline-flex",
              }}
            >
              <Tooltip title="Delete All Uploaded Files" placement="top">
                <IconButton
                  disabled={
                    activeFileUploadAreaData.uploadAreaFiles.length === 0
                  }
                  onClick={() => {
                    dispatch(
                      FileUploadAreaAndPreviewReducerAction.updateUploadAreaFiles(
                        []
                      )
                    );
                  }}
                >
                  <Delete
                    sx={{
                      color:
                        activeFileUploadAreaData.uploadAreaFiles.length !== 0
                          ? "grey"
                          : "",
                    }}
                    disabled={
                      activeFileUploadAreaData.uploadAreaFiles.length === 0
                    }
                  ></Delete>
                </IconButton>
              </Tooltip>
            </Box>
          )}
        {thumbs && thumbs.length > 0 && (
          <div style={uploadedFilesAreaStyles}>
            {thumbs && thumbs.length > 0 && (
              <aside style={thumbsContainer}>{thumbs}</aside>
            )}
            {((acceptedFileItems && acceptedFileItems.length > 0) ||
              (fileRejectionItems && fileRejectionItems.length > 0)) && (
              <aside>
                {acceptedFileItems && acceptedFileItems.length > 0 && (
                  <React.Fragment>
                    <h4>Attached Files Successfully : </h4>
                    <ul>{acceptedFileItems}</ul>
                  </React.Fragment>
                )}
                {fileRejectionItems && fileRejectionItems.length > 0 && (
                  <React.Fragment>
                    <h4>Attachement Failed Files : </h4>
                    <ul>{fileRejectionItems}</ul>
                  </React.Fragment>
                )}
              </aside>
            )}
          </div>
        )}
      </section>

      <Dialog
        open={dlgOpen}
        fullScreen
        aria-describedby="alert-dialog-slide-description"
      >
        <Paper>
          <DialogTitle>{"Hand Over File Preview"}</DialogTitle>
          <DialogContent>
            <h4>{"Hand Over File Preview"}</h4>
            {selectedPreviewFile &&
              selectedPreviewFile.type.includes("image") && (
                <DynamicImgResizeComponent
                  imageProps={{
                    ...imageProps,
                    ...{
                      originalImg: selectedPreviewFile.preview,
                      imgType: selectedPreviewFile.type,
                    },
                  }}
                />
              )}
            {selectedPreviewFile &&
              !selectedPreviewFile.type.includes("image") && (
                <object data={selectedPreviewFile.preview} style={pdf} />
              )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setDlgOpen(false)}>Close</Button>
          </DialogActions>
        </Paper>
      </Dialog>
    </React.Fragment>
  );
};

export default FileUploadAreaAndPreview;
